import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=78b12702"
import script from "./ItemsTable.vue?vue&type=script&lang=ts"
export * from "./ItemsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports